var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgGoogleDocs = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.6658 0.833313H4.58273C4.25366 0.841465 3.94034 0.975924 3.70772 1.20882C3.4751 1.44171 3.34101 1.75519 3.33325 2.08426V17.9157C3.34103 18.245 3.47532 18.5587 3.70826 18.7916C3.94119 19.0246 4.25488 19.1589 4.58421 19.1666H15.4149C15.7442 19.1589 16.0579 19.0246 16.2908 18.7916C16.5238 18.5587 16.658 18.245 16.6658 17.9157V5.83415L13.7498 3.74934L11.6658 0.833313Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.66602 14.1651H13.3323V13.3321H6.66602V14.1651ZM6.66602 15.8318H11.6652V14.9988H6.66602V15.8318ZM6.66602 9.99894V10.832H13.3323V9.99878L6.66602 9.99894ZM6.66602 12.4985H13.3323V11.6655H6.66602V12.4985Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6655 0.833313V4.58304C11.6735 4.9119 11.8077 5.2251 12.0403 5.45771C12.2729 5.69033 12.5861 5.82453 12.915 5.8325H16.6647L11.6655 0.833313Z",
    fill: "#A1C2FA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleDocs, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google-docs.c4cc23de.svg";
export { ForwardRef as ReactComponent };